// @ts-nocheck
import {useEffect, useMemo, useState, useRef, useCallback} from 'react'
import {useTable, ColumnInstance, Row, usePagination} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {usersColumns} from './columns/_columns'
import {User} from '../core/_models'
import {KTCardBody, KTSVG} from '../../../../../_metronic/helpers'
import {useListView} from '../../../../modules/apps/user-management/users-list/core/ListViewProvider'
import {CustomRow} from './columns/CustomRow'
// import {gql, useQuery} from '@apollo/client'
import {UsersListLoading} from '../components/loading/UsersListLoading'
import {UsersListPagination} from '../components/pagination/UsersListPagination'
import {AGENT_ACCOUNT_TYPE} from '../../../../../constant'
import axios from 'axios'
import {BASE_URL} from '../../../../../api'

type SearchProps = {
  userSearch: String
  setUserSearch: Function
  onDataChange?: (data: any[]) => void
}

// const clean = (text) => text.replace(/[^a-zA-Z0-9 ]/g, '')

const UsersTable = ({
  sDate,
  eDate,
  genderFilter,
  setGenderFilter,
  userSearch,
  setUserSearch,
  page,
  setPage,
  loading,
  setLoading,
  applyFilter,
  setApplyFilter,
  onDataChange,
}: SearchProps) => {
  let gender = genderFilter
  const [loadingTrue, setLoadingTrue] = useState<boolean>(false)
  const [userData, setUserData] = useState([]) // Store user data
  const [paginationDetails, setPaginationDetails] = useState({})

  // Track previous values to detect actual changes
  const prevValuesRef = useRef({
    userSearch: '',
    page: 1,
    sDate: '',
    eDate: '',
    applyFilter: false,
  })

  // Add a timestamp to force refresh when same page is clicked
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  // Component mount effect
  useEffect(() => {
    console.log('🚀 UsersTable component mounted!')
    console.log('Initial props:', {userSearch, page, sDate, eDate, applyFilter})
    console.log('BASE_URL:', BASE_URL)

    // Test API connectivity
    console.log('Testing API connectivity...')
    axios
      .get(`${BASE_URL}/admin/transactions`)
      .then((response) => {
        console.log('✅ API test successful:', response.status)
      })
      .catch((error) => {
        console.error('❌ API test failed:', error.message)
        if (error.response) {
          console.error('Response status:', error.response.status)
          console.error('Response data:', error.response.data)
        }
      })
  }, [])

  // Function to fetch data
  const fetchData = async () => {
    try {
      console.log('Starting API call...')
      setLoading(true)
      const params = {
        page,
        query: userSearch,
        // includeStripeDetails: true,
      }

      // Add filter dates to the request if they are defined and not empty
      if (sDate && sDate !== '' && eDate && eDate !== '') {
        params.startDate = sDate
        params.endDate = eDate
      }

      console.log('Fetching data with params:', params)
      console.log('API URL:', `${BASE_URL}/admin/transactions`)

      const response = await axios.get(`${BASE_URL}/admin/transactions`, {
        params,
      })

      const {docs, ...pagination} = response.data
      console.log('Received data:', docs)
      console.log('Response status:', response.status)
      setUserData(docs)
      setPaginationDetails(pagination)

      // Notify parent component about data change
      if (onDataChange) {
        onDataChange(docs)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      console.error('Error details:', {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      })
    } finally {
      setLoading(false)
    }
  }

  // Main effect for data fetching - detects all changes including page navigation
  useEffect(() => {
    const currentValues = {userSearch, page, sDate, eDate, applyFilter}
    const prevValues = prevValuesRef.current

    // Check if any values have changed
    const hasChanged =
      prevValues.userSearch !== userSearch ||
      prevValues.page !== page ||
      prevValues.sDate !== sDate ||
      prevValues.eDate !== eDate ||
      prevValues.applyFilter !== applyFilter

    console.log('useEffect triggered:', {
      currentValues,
      prevValues,
      hasChanged,
      isInitial: prevValues.userSearch === '',
    })

    // Always fetch on initial load or if any values changed
    if (prevValues.userSearch === '' || hasChanged) {
      console.log('Fetching data...')
      fetchData()

      // Update previous values
      prevValuesRef.current = currentValues
    }
  }, [userSearch, page, sDate, eDate, applyFilter, refreshTrigger])

  // Effect to handle refresh trigger
  useEffect(() => {
    if (refreshTrigger > 0) {
      console.log('Refresh triggered, fetching data...')
      fetchData()
    }
  }, [refreshTrigger])

  console.log('Component render - userData:', userData, 'loading:', loading)
  const data = useMemo(() => userData, [userData])
  const columns = useMemo(() => usersColumns, [])

  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      {loading && <UsersListLoading />}
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<User>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<User>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    {loading ? 'Loading...' : 'No matching records found'}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <UsersListPagination
        page={page}
        setPage={setPage}
        totalPages={paginationDetails.totalPages}
        loading={loading}
        paginationDetails={paginationDetails}
        onRefresh={() => setRefreshTrigger((prev) => prev + 1)}
      />
      {/* {isFetching && <UsersListLoading />} */}
    </KTCardBody>
  )
}

export {UsersTable}
